<template>
  <div>
    <footer class="bg-white" aria-labelledby="footer-heading">
      <h2 id="footer-heading" class="sr-only">Footer</h2>
      <div class="px-4 py-12 mx-auto bg-gray-50 max-w-7xl sm:px-6 lg:px-16">
        <div class="flex flex-wrap items-baseline lg:justify-center">
          <span class="mt-2 text-sm font-light text-gray-600">
            Creador Por Jafeht Soturno © 2022
          </span>
        </div>
        
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
